<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#a)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m15.4 3.5.9.8a2395.2 2395.2 0 0 0 2 .4L21 22.4l-6.4 1.4.8-20.3Zm-1-.7-.8.3C13.2 1.8 12.4.7 11.1.7H11c-.4-.5-.8-.7-1.2-.7-3.1 0-4.6 3.9-5 5.8l-2.2.7c-.7.2-.7.2-.8.9L0 21.4 13.6 24l.8-21.2Zm-3.5 1v.1l-2.4.8c.5-1.8 1.3-2.7 2-3 .3.5.4 1.2.4 2ZM9.7.8l.4.2c-1 .4-2 1.6-2.5 4l-1.9.5C6.2 3.7 7.5.8 9.7.8Zm.5 10.5s-.8-.4-1.8-.4C7 10.9 7 11.8 7 12c0 1.2 3.2 1.7 3.2 4.6 0 2.3-1.4 3.8-3.3 3.8a4.7 4.7 0 0 1-3.6-1.5l.6-2s1.3 1 2.3 1c.7 0 1-.5 1-1 0-1.5-2.7-1.6-2.7-4.3 0-2.2 1.6-4.4 4.9-4.4 1.2 0 1.8.4 1.8.4l-.9 2.7Zm1.5-7.6v-.3c0-.7-.1-1.4-.3-1.9.7.1 1.2 1 1.5 1.8l-1.2.4Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="currentColor"
          d="M0 0h21v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
</template>
